/**
 * Router.js
 *
 * Copyright (c) 2026 Eric Seigne <eric.seigne@cap-rel.fr>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

// Minimal hash router for SPA navigation
export class Router {
  constructor() {
    this.routes = new Map()
    this.current = null
    window.addEventListener('hashchange', () => this.resolve())
  }

  register(path, handler) {
    this.routes.set(path, handler)
    return this
  }

  navigate(path) {
    window.location.hash = path
  }

  resolve() {
    const hash = window.location.hash.slice(1) || '/'
    this.current = hash
    const handler = this.routes.get(hash) || this.routes.get('/404')
    if (handler) handler(hash)
  }

  start() {
    this.resolve()
  }
}
